var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgDart = function SvgDart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#66C3FA",
    d: "M8.147-.103c-.174 0-.349.07-.484.203l-.007.005L3.12 2.77l4.525 4.597v.004l5.438 5.526L14.12 11l-3.739-9.12L8.637.104a.685.685 0 0 0-.49-.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#215896",
    d: "M3.325 2.564.662 7.084l-.005.007a.679.679 0 0 0 .004.971l2.208 2.169 8.633 3.333 1.951-1.064-.052-.052-.014.002-5.412-5.321H7.97L3.325 2.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235997",
    d: "m3.12 2.564 4.631 4.649h.007l5.33 5.351 2.03-.388.002-6.02-2.142-2.105c-.47-.462-1.19-.759-1.915-.856l.002-.024-7.944-.607Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58B6F0",
    d: "m3.12 2.564 4.65 4.633v.007l5.35 5.332-.39 2.028H6.709l-2.106-2.143c-.46-.47-.758-1.19-.855-1.915l-.024.001-.603-7.943Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDart);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;